import React, { Component } from 'react';
import { BrowserRouter as Router, Switch, Route, Redirect } from "react-router-dom";
import { createBrowserHistory } from "history";
import './App.css';
import App from './App';

class FlixRoute extends Component {
    render() {

        const history = createBrowserHistory();

        return (
            <Router history={history}>
                <Switch>
                    <Route path="/*" component={App} />
                </Switch>
            </Router>
        );
    }
}

export default FlixRoute;